import _ from 'lodash';
import React from 'react';
import axios from 'axios';
import { env } from '~/commons/config';
import Header from '../layout/Header.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { Form, Formik } from 'formik';
import { object, ref, string } from 'yup';
import FormErrorAlert from '../../../admin/components/forms/FormErrorAlert.jsx';
import { useAlert } from '../../../commons/components/alert/index.jsx';

const PageUser = () => {

  const { user: { email, name, orgIds } = {} } = env || {};

  const breadcrumb = [
    { children: 'User' },
  ];

  const showAlert = useAlert();

  return (
    <div className="py-4">
      <Header breadcrumb={breadcrumb}>Edit</Header>
      <Formik
        initialValues={{ email, name, orgIds: _.join(orgIds, ',') }}
        validationSchema={object({
          password: string().required().matches(
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
            'Password must at least 8 characters, one uppercase, one lowercase, one number',
          ),
          confirmPassword: string().when('password', {
            is: (p) => p,
            then: (s) => s.required().oneOf([ref('password')], 'Password does not match'),
          }),
        })}
        onSubmit={async (values) => {
          try {
            const res = await axios.post('/api/core/users/self/change-password', {
              password: values.password,
            });

            if (res.status === 200) {
              showAlert('success', 'Saved succesfully', 2000);
            } else {
              showAlert('danger', 'Unknown error', 2000);
            }

          } catch (e) {
            if (e.response?.status === 400) {
              showAlert('danger', e.response.data, 2000);
            } else {
              showAlert('danger', e, 2000);
            }
          }
        }}
      >
        {(props) => (
          <Form>
            <FormErrorAlert {...props} />
            <button className='btn btn-primary mb-3'>Save</button>
            <div className="row">
              <div className="col-12">
                <FormGroup name="email" disabled />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FormGroup name="name.full.en" label="Name (English)" disabled />
              </div>
              <div className="col-6">
                <FormGroup name="orgIds" label="Organization ID (Comma separated)" disabled />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FormGroup name="password" label="Password" type="password" />
              </div>
              <div className="col-6">
                <FormGroup name="confirmPassword" label="Confirm Password" type="password" />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PageUser;
